import React from "react"
import { bkSubMain } from "./general"
import IncidentesPlaneados from "./IncidentesPlaneados"

export default function PlanUsuario({ listaIncidentes, usuario }) {
    let grupo = ["7 dias", "15 dias", "Mediano plazo"]

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <div style={Scolumna}>
                {grupo.map((g, i) =>
                    <div key={g} style={SceldaIncidentes}>
                        <IncidentesPlaneados incidentes={listaIncidentes[g]} usuario={usuario} />
                    </div>
                )}
            </div>
        </div >
    )
}

const Scolumna = {
    width: "100%",
    height: "100%",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
}

const SceldaIncidentes = {
    width: "30%",
    border: "1px solid #e6e6e6",
    background: bkSubMain,
    borderRadius: "5px",
    height: "95%",
    overflowY: "auto",
    margin: "3px"
}